import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import { CREATE_PACKAGE_PRICE, UPDATE_PACKAGE_PRICE } from "../../../Schema/PackagePrice";

const usePackagePriceForm = ({ handleClose, resetForm, setRefetch }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createPackagePrice] = useMutation(CREATE_PACKAGE_PRICE, {
    onCompleted: ({ createPackagePrice }) => {
      setLoading(false);

      if (createPackagePrice?.isSuccess === true) {
        // console.log("createPackagePrice::", createPackagePrice)
        setAlert(true, "success", createPackagePrice?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createPackagePrice?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updatePackagePrice] = useMutation(UPDATE_PACKAGE_PRICE, {
    onCompleted: ({ updatePackagePrice }) => {
      setLoading(false);
      if (updatePackagePrice?.isSuccess === true) {
        setAlert(true, "success", updatePackagePrice?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updatePackagePrice?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  return { updatePackagePrice, createPackagePrice, loading, setLoading };
};

export default usePackagePriceForm;
